var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowUpward(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.00000671397,
    width: 38.3994,
    height: 38.3994,
    rx: 19.1997,
    fill: "#F4F3F9",
    fillOpacity: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1033_23231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0315 25.031L20.0315 15.7227L24.0982 19.7893C24.4232 20.1143 24.9565 20.1143 25.2815 19.7893C25.6065 19.4643 25.6065 18.9393 25.2815 18.6143L19.7898 13.1227C19.4648 12.7977 18.9398 12.7977 18.6148 13.1227L13.1148 18.606C12.7898 18.931 12.7898 19.456 13.1148 19.781C13.4398 20.106 13.9648 20.106 14.2898 19.781L18.3648 15.7227L18.3648 25.031C18.3648 25.4893 18.7398 25.8643 19.1982 25.8643C19.6565 25.8643 20.0315 25.4893 20.0315 25.031Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1033_23231"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(9.19922 9.19923)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpward);
export default __webpack_public_path__ + "static/media/arrow_upward.3710da5742bea2ca813d184c0e4b7c60.svg";
export { ForwardRef as ReactComponent };